import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['../../assets/css/light.theme.css'],
  styles: [`
      .terms {
          list-style-type: none;
          text-align: justify;
      }

      p {
          text-align: justify !important;
      }

      h5 {
          font-weight: bold;
          color: gray;
          text-align: right;
      }

      .paragraph {
          text-align: justify;
      }

      .card-2 .card-heading {
          background: none !important;
          width: 0 !important;
      }
  `]
})
export class TermsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
